var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 8,
    viewBox: "0 0 5 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.83656 3.56596C5.05448 3.81577 5.05448 4.19048 4.83656 4.4153L1.54358 7.81265C1.30145 8.06245 0.938257 8.06245 0.720339 7.81265L0.163438 7.26308C-0.0544791 7.01327 -0.0544791 6.63856 0.163438 6.41374L2.51211 3.99063L0.163438 1.59251C-0.0544791 1.36768 -0.0544791 0.967994 0.163438 0.743169L0.720339 0.168618C0.938257 -0.0562061 1.30145 -0.0562061 1.54358 0.168618L4.83656 3.56596Z",
    fill: "#BBBBBB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.0976d6746eeb90f83d4d21dae8b9f224.svg";
export { ForwardRef as ReactComponent };